var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpresas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E48E81;}\r\n\t.st1{fill:#407094;}\r\n\t.st2{fill:#F7EFF0;}\r\n\t.st3{fill:#E1DFE2;}\r\n\t.st4{fill:#2C4D66;}\r\n\t.st5{fill:#E1646F;}\r\n\t.st6{fill:#6FBDF4;}\r\n\t.st7{fill:#8FD8FA;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Train station") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,11.5C3,10.7,3.7,10,4.5,10h7c0.8,0,1.5,0.7,1.5,1.5V13H3V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21,11.5c0-0.8-0.7-1.5-1.5-1.5h-7c-0.8,0-1.5,0.7-1.5,1.5V13h10V11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,6h10c0.6,0,1,0.4,1,1l0,0c0,0.6-0.4,1-1,1H7C6.4,8,6,7.6,6,7l0,0C6,6.4,6.4,6,7,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,14c0-0.6,0.4-1,1-1h4v2H3C2.4,15,2,14.6,2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22,14c0-0.6-0.4-1-1-1h-4v2h4C21.6,15,22,14.6,22,14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    className: "st2",
    width: 10,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    className: "st3",
    width: 4,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    className: "st3",
    width: 4,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2,21c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1v1H2V21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7,4.5C7,3.7,7.7,3,8.5,3h7C16.3,3,17,3.7,17,4.5V6H7V4.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    className: "st0",
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    className: "st6",
    width: 10,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    className: "st7",
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11,17c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.4,1,1v3h-2V17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,17c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.4,1,1v3h-2V17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4,17c0-0.6,0.4-1,1-1l0,0c0.6,0,1,0.4,1,1v3H4V17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresas);
export default __webpack_public_path__ + "static/media/empresas.6d963bf24f698da487260d2ca9c520b1.svg";
export { ForwardRef as ReactComponent };